var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationTutoring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4857_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.2851 0.378413C53.1152 0.288413 51.9351 0.248413 50.7451 0.248413C23.1351 0.248413 0.745148 22.6384 0.745148 50.2484C0.745148 77.8584 23.1351 100.248 50.7451 100.248C72.3051 100.248 90.6751 86.5984 97.6951 67.4784C99.6651 62.1084 100.745 56.2984 100.745 50.2484C100.745 23.8284 80.2451 2.18841 54.2851 0.378413ZM90.8151 68.4284C83.8751 83.6484 68.5251 94.2484 50.7451 94.2484C26.4851 94.2484 6.74515 74.5084 6.74515 50.2484C6.74515 42.7784 8.61515 35.7484 11.9151 29.5784C19.3251 15.7084 33.9551 6.24841 50.7451 6.24841C75.0051 6.24841 94.7451 25.9884 94.7451 50.2484C94.7451 56.7284 93.3351 62.8884 90.8151 68.4284Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5951 75.6584L50.7451 76.0784L49.8951 75.6584C39.1351 70.3484 27.8751 66.7184 18.1751 65.4284L16.5451 65.2084L16.5051 63.5684C16.3151 54.8284 16.3851 39.1984 16.4351 31.3184H15.8951C14.6551 31.3184 13.6451 32.3184 13.6251 33.5584L13.6051 36.0584C13.6051 36.3084 13.3651 51.6284 13.6351 63.6284L13.6851 65.7884C13.7051 66.9084 14.5451 67.8384 15.6551 67.9884L17.7951 68.2784C22.4851 68.8984 27.5751 70.0984 32.7951 71.7784C38.0151 73.4684 43.3751 75.6384 48.6151 78.2284C49.9551 78.8884 51.5151 78.8884 52.8551 78.2284C63.3451 73.0584 74.2851 69.5184 83.6751 68.2784L85.8151 67.9884C86.9251 67.8384 87.7551 66.9084 87.7851 65.7884L87.8351 63.6284C88.0951 51.6384 87.8652 36.3084 87.8652 36.0584L87.8451 33.5584C87.8351 32.3184 86.8251 31.3184 85.5751 31.3184H85.0351C85.0951 39.1884 85.1651 54.8284 84.9651 63.5684L84.9251 65.2084L83.2952 65.4284C73.6051 66.7184 62.3352 70.3484 51.5751 75.6584H51.5951Z",
    fill: "#FF4D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7451 73.9384C60.3151 69.2184 71.8751 65.0184 83.0551 63.5284C83.2451 54.7584 83.1751 39.1684 83.1152 31.3284C83.0952 28.3884 83.0751 26.5384 83.0751 26.5384C70.0251 26.5384 57.3852 30.7184 50.7351 37.9284C44.0851 30.7084 31.4551 26.5384 18.3951 26.5384C18.3951 26.5384 18.3751 28.3884 18.3551 31.3284C18.2951 39.1684 18.2251 54.7584 18.4251 63.5284C29.6051 65.0084 41.1651 69.2184 50.7351 73.9384H50.7451ZM69.0651 60.4984C63.6351 61.5584 59.1251 63.5384 56.3751 66.0684C56.1852 66.2384 55.9551 66.3184 55.7251 66.3184C55.4651 66.3184 55.2051 66.2184 55.0251 66.0084C54.6651 65.6184 54.6951 65.0084 55.0851 64.6584C58.0951 61.8884 62.9251 59.7484 68.7051 58.6184C69.2251 58.5184 69.7252 58.8584 69.8251 59.3784C69.9251 59.8984 69.5851 60.3984 69.0651 60.4984ZM55.0251 41.0784C59.6751 36.0284 68.5051 32.8984 78.0751 32.8984C78.6051 32.8984 79.0351 33.3284 79.0351 33.8584C79.0351 34.3884 78.6051 34.8184 78.0751 34.8184C69.0251 34.8184 60.7351 37.7184 56.4351 42.3784C56.2451 42.5784 55.9851 42.6884 55.7351 42.6884C55.5051 42.6884 55.2651 42.6084 55.0851 42.4384C54.6951 42.0784 54.6751 41.4684 55.0251 41.0884V41.0784ZM55.0551 49.3884C59.6951 44.7984 68.5251 41.9484 78.0751 41.9484C78.6051 41.9484 79.0351 42.3784 79.0351 42.9084C79.0351 43.4384 78.6051 43.8684 78.0751 43.8684C69.0051 43.8684 60.7051 46.5084 56.4051 50.7584C56.2151 50.9484 55.9752 51.0384 55.7351 51.0384C55.4951 51.0384 55.2451 50.9384 55.0551 50.7484C54.6852 50.3684 54.6852 49.7684 55.0551 49.3984V49.3884ZM55.0551 57.6984C59.6951 53.1284 68.5152 50.2884 78.0751 50.2884C78.6051 50.2884 79.0351 50.7184 79.0351 51.2484C79.0351 51.7784 78.6051 52.2084 78.0751 52.2084C69.0051 52.2084 60.7051 54.8384 56.4051 59.0684C56.2151 59.2484 55.9752 59.3384 55.7351 59.3384C55.4951 59.3384 55.2351 59.2384 55.0551 59.0484C54.6852 58.6684 54.6851 58.0684 55.0651 57.6984H55.0551ZM43.5351 57.1584L40.3951 52.7184L41.1451 52.1384L46.1951 59.2084V62.6984C38.9851 59.5684 32.1051 57.4884 24.7851 56.2484L27.9351 51.4084L30.6551 55.5484C30.9951 56.0584 31.6851 56.2084 32.1951 55.8684C32.7051 55.5284 32.8551 54.8384 32.5151 54.3284L31.5251 52.8284L34.5351 48.2984L41.7151 58.4484C41.9352 58.7584 42.2752 58.9184 42.6251 58.9184C42.8451 58.9184 43.0751 58.8484 43.2651 58.7184C43.7651 58.3584 43.8851 57.6684 43.5351 57.1684V57.1584ZM28.3351 36.6884C30.3551 36.6884 32.0051 38.3284 32.0051 40.3584C32.0051 42.3884 30.3651 44.0284 28.3351 44.0284C26.3051 44.0284 24.6651 42.3884 24.6651 40.3584C24.6651 38.3284 26.3051 36.6884 28.3351 36.6884Z",
    fill: "#FF4D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4857_1694",
    x: 0.0000118613,
    y: 0.0000344813,
    width: 101.49,
    height: 102.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4857_1694"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4857_1694",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4857_1694"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4857_1694",
    result: "effect3_innerShadow_4857_1694"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationTutoring);
export default __webpack_public_path__ + "static/media/EducationTutoring.c77c8ff952300a44153be8f3a807b6be.svg";
export { ForwardRef as ReactComponent };